import React, { useState, useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../App";

function AdminDashboard() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [userName, setUserName] = useState("");
  const [profilePhoto, setProfilePhoto] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    if (userId) {
      axios.get(`${baseUrl}/get/${userId}`)
        .then(res => {
          setUserName(res.data.name);
          setProfilePhoto(res.data.profilePhotoPath);
        })
        .catch(err => console.error(err));
    }
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div className="container-fluid p-0">
      <div className="row g-0">

        {/* Sidebar */}
        <div
          className={`bg-dark text-white p-3 position-fixed start-0 top-0
          ${showSidebar ? "d-block" : "d-none"} d-md-block`}
          style={{ zIndex: 1050, width: "250px", height: "100vh", left: 0 }}
        >
          <div className="text-center mb-4">
           
            <h6>Admin Panel</h6>
            <hr style={{ backgroundColor: '#ffb300', height: '2px', border: 'none', margin: '10px 0' }} />
          </div>

          <style>
            {`
              .nav-link.text-white {
                transition: all 0.3s ease;
                border-radius: 5px;
                padding: 10px 15px;
              }
              .nav-link.text-white:hover {
                background-color: #ffb300;
                color: #000 !important;
                transform: translateX(5px);
              }
            `}
          </style>

          <ul className="nav flex-column">

            <li className="nav-item mb-2">
              <Link to="manage-users" className="nav-link text-white" onClick={() => setShowSidebar(false)}>
                Manage Users
              </Link>
            </li>

          

            <li className="nav-item mb-2">
              <Link to="adminProfile" className="nav-link text-white" onClick={() => setShowSidebar(false)}>
                Profile
              </Link>
            </li>

              <li className="nav-item mb-2">
                          <Link to="community" className="nav-link text-white" onClick={() => setShowSidebar(false)}>
                            Community
                          </Link>
                        </li>

         
            <li className="nav-item mt-3">
              <button
                onClick={handleLogout}
                className="btn btn-danger w-100"
              >
                Logout
              </button>
            </li>

          </ul>
        </div>

        {/* ☰ Mobile Toggle Button */}
        <div className="d-md-none bg-dark text-white position-fixed top-0 d-flex align-items-center justify-content-between" style={{ zIndex: 1040, left: 0, width: "100%", height: "50px", padding: "0 10px" }}>
          <button
            className="btn btn-light btn-sm"
            onClick={() => setShowSidebar(!showSidebar)}
          >
            ☰ Menu
          </button>
          <span className="text-white fw-bold" style={{ fontSize: "14px" }}>
            Welcome, {userName?.split(' ')[0] || "Admin"}
          </span>
         
        </div>

        {/* Overlay for mobile */}
        {showSidebar && (
          <div
            className="d-md-none position-fixed top-0 start-0 w-100 h-100 bg-dark"
            style={{ zIndex: 1045, opacity: 0.5 }}
            onClick={() => setShowSidebar(false)}
          />
        )}

        {/* Main Content */}
        <div className="p-0" style={{ marginTop: window.innerWidth >= 768 ? "0px" : "45px", marginLeft: window.innerWidth >= 768 ? "250px" : "0", width: window.innerWidth >= 768 ? "calc(100% - 250px)" : "100%" }}>
          <Outlet />
        </div>

      </div>
    </div>
  );
}

export default AdminDashboard;
